/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 14:08:39
 * @LastEditors: 陈芳 1441861445@qq.com
 * @LastEditTime: 2023-03-23 23:51:49
 */
import TextButton from './text';
export default {
	TextButton,
};
